//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch
} from 'rxjs/operators';
import {
  Observable,
  throwError as _observableThrow,
  of as _observableOf
} from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase
} from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
  providedIn: 'root'
})
export class Service {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? '';
  }

  getHealth(): Observable<void> {
    let url_ = this.baseUrl + '/avaliacoes-service/health';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetHealth(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetHealth(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processGetHealth(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param authorization (optional) Bearer token
   * @return Cria uma avaliação
   */
  inserirAvaliacao(
    body: ReceiveDataEvaluation,
    authorization?: string | undefined
  ): Observable<AvaliacaoResponse> {
    let url_ = this.baseUrl + '/avaliacoes-service/avaliacao/inserir';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Authorization:
          authorization !== undefined && authorization !== null
            ? '' + authorization
            : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processInserirAvaliacao(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processInserirAvaliacao(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<AvaliacaoResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<AvaliacaoResponse>;
        })
      );
  }

  protected processInserirAvaliacao(
    response: HttpResponseBase
  ): Observable<AvaliacaoResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AvaliacaoResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param authorization (optional) Bearer token
   * @return Retorna uma avaliação especifica
   */
  buscaUltimaAvaliacao(
    setorId: string,
    tipoAvalicaoId: string,
    authorization?: string | undefined
  ): Observable<BuscaUltimaAvaliacaoRetorno> {
    let url_ =
      this.baseUrl + '/avaliacoes-service/avaliacao/{setorId}/{tipoAvalicaoId}';
    if (setorId === undefined || setorId === null)
      throw new Error("The parameter 'setorId' must be defined.");
    url_ = url_.replace('{setorId}', encodeURIComponent('' + setorId));
    if (tipoAvalicaoId === undefined || tipoAvalicaoId === null)
      throw new Error("The parameter 'tipoAvalicaoId' must be defined.");
    url_ = url_.replace(
      '{tipoAvalicaoId}',
      encodeURIComponent('' + tipoAvalicaoId)
    );
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Authorization:
          authorization !== undefined && authorization !== null
            ? '' + authorization
            : '',
        Accept: 'application/json'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBuscaUltimaAvaliacao(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBuscaUltimaAvaliacao(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<BuscaUltimaAvaliacaoRetorno>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<BuscaUltimaAvaliacaoRetorno>;
        })
      );
  }

  protected processBuscaUltimaAvaliacao(
    response: HttpResponseBase
  ): Observable<BuscaUltimaAvaliacaoRetorno> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BuscaUltimaAvaliacaoRetorno.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param authorization (optional) Bearer token
   * @return Retorna todos os setores cadastrados
   */
  buscaSetores(
    authorization?: string | undefined
  ): Observable<SetoresResponse> {
    let url_ = this.baseUrl + '/avaliacoes-service/setores';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Authorization:
          authorization !== undefined && authorization !== null
            ? '' + authorization
            : '',
        Accept: 'application/json'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBuscaSetores(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBuscaSetores(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SetoresResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<SetoresResponse>;
        })
      );
  }

  protected processBuscaSetores(
    response: HttpResponseBase
  ): Observable<SetoresResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SetoresResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id Id do setor que deseja buscar
   * @param authorization (optional) Bearer token
   * @return Retorna um setor especifico
   */
  buscaSetor(
    id: any,
    authorization?: string | undefined
  ): Observable<SetorResponse> {
    let url_ = this.baseUrl + '/avaliacoes-service/setor/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Authorization:
          authorization !== undefined && authorization !== null
            ? '' + authorization
            : '',
        Accept: 'application/json'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBuscaSetor(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBuscaSetor(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SetorResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<SetorResponse>;
        })
      );
  }

  protected processBuscaSetor(
    response: HttpResponseBase
  ): Observable<SetorResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SetorResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param authorization (optional) Bearer token
   * @return Retorna todos tipos de avaliações
   */
  buscaTipoAvaliacoes(
    authorization?: string | undefined
  ): Observable<TipoAvaliacoesResponse[]> {
    let url_ = this.baseUrl + '/avaliacoes-service/tipo-avaliacoes';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Authorization:
          authorization !== undefined && authorization !== null
            ? '' + authorization
            : '',
        Accept: 'application/json'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBuscaTipoAvaliacoes(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBuscaTipoAvaliacoes(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                TipoAvaliacoesResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              TipoAvaliacoesResponse[]
            >;
        })
      );
  }

  protected processBuscaTipoAvaliacoes(
    response: HttpResponseBase
  ): Observable<TipoAvaliacoesResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(TipoAvaliacoesResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id Id do tipo de avaliação que deseja buscar
   * @param authorization (optional) Bearer token
   * @return Retorna um tipo de avaliação especifico
   */
  buscaAvaliacao(
    id: any,
    authorization?: string | undefined
  ): Observable<TipoAvaliacaoResponse> {
    let url_ = this.baseUrl + '/avaliacoes-service/tipo-avaliacao/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Authorization:
          authorization !== undefined && authorization !== null
            ? '' + authorization
            : '',
        Accept: 'application/json'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBuscaAvaliacao(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBuscaAvaliacao(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<TipoAvaliacaoResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<TipoAvaliacaoResponse>;
        })
      );
  }

  protected processBuscaAvaliacao(
    response: HttpResponseBase
  ): Observable<TipoAvaliacaoResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TipoAvaliacaoResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export class ReceiveDataEvaluation {
  /** ID do setor registrado no DB, whatsapp | portal etc... */
  setorId!: number;
  /** ID do tipo de avaliação no DB, CSAT | NPS etc... */
  tipoAvaliacaoId!: number;
  /** Deve estar dentro do range de pontuação do tipo de avaliação */
  pontuacao!: number;
  /** Descreve o motivo da pontuação dada */
  motivo?: string;

  [key: string]: any;

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.setorId =
        _data['setorId'] !== undefined ? _data['setorId'] : <any>null;
      this.tipoAvaliacaoId =
        _data['tipoAvaliacaoId'] !== undefined
          ? _data['tipoAvaliacaoId']
          : <any>null;
      this.pontuacao =
        _data['pontuacao'] !== undefined ? _data['pontuacao'] : <any>null;
      this.motivo = _data['motivo'] !== undefined ? _data['motivo'] : <any>null;
    }
  }

  static fromJS(data: any): ReceiveDataEvaluation {
    data = typeof data === 'object' ? data : {};
    let result = new ReceiveDataEvaluation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['setorId'] = this.setorId !== undefined ? this.setorId : <any>null;
    data['tipoAvaliacaoId'] =
      this.tipoAvaliacaoId !== undefined ? this.tipoAvaliacaoId : <any>null;
    data['pontuacao'] =
      this.pontuacao !== undefined ? this.pontuacao : <any>null;
    data['motivo'] = this.motivo !== undefined ? this.motivo : <any>null;
    return data;
  }
}

export class ResponseEvaluationDto {
  /** ID do setor registrado no DB, whatsapp | portal etc... */
  setorId!: number;
  /** ID do tipo de avaliação no DB, CSAT | NPS etc... */
  tipoAvaliacaoId!: number;
  /** Deve estar dentro do range de pontuação do tipo de avaliação */
  pontuacao!: number;
  /** Descreve o motivo da pontuação dada */
  motivo?: string;
  /** cpf do avaliador */
  cpf!: string;
  id!: number;
  createdAt!: Date;
  updatedAt!: Date;

  [key: string]: any;

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.setorId =
        _data['setorId'] !== undefined ? _data['setorId'] : <any>null;
      this.tipoAvaliacaoId =
        _data['tipoAvaliacaoId'] !== undefined
          ? _data['tipoAvaliacaoId']
          : <any>null;
      this.pontuacao =
        _data['pontuacao'] !== undefined ? _data['pontuacao'] : <any>null;
      this.motivo = _data['motivo'] !== undefined ? _data['motivo'] : <any>null;
      this.cpf = _data['cpf'] !== undefined ? _data['cpf'] : <any>null;
      this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>null;
      this.updatedAt = _data['updatedAt']
        ? new Date(_data['updatedAt'].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): ResponseEvaluationDto {
    data = typeof data === 'object' ? data : {};
    let result = new ResponseEvaluationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['setorId'] = this.setorId !== undefined ? this.setorId : <any>null;
    data['tipoAvaliacaoId'] =
      this.tipoAvaliacaoId !== undefined ? this.tipoAvaliacaoId : <any>null;
    data['pontuacao'] =
      this.pontuacao !== undefined ? this.pontuacao : <any>null;
    data['motivo'] = this.motivo !== undefined ? this.motivo : <any>null;
    data['cpf'] = this.cpf !== undefined ? this.cpf : <any>null;
    data['id'] = this.id !== undefined ? this.id : <any>null;
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>null;
    data['updatedAt'] = this.updatedAt
      ? this.updatedAt.toISOString()
      : <any>null;
    return data;
  }
}

export class AvaliacaoResponse {
  data!: ResponseEvaluationDto;

  [key: string]: any;

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.data = _data['data']
        ? ResponseEvaluationDto.fromJS(_data['data'])
        : new ResponseEvaluationDto();
    }
  }

  static fromJS(data: any): AvaliacaoResponse {
    data = typeof data === 'object' ? data : {};
    let result = new AvaliacaoResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['data'] = this.data ? this.data.toJSON() : <any>null;
    return data;
  }
}

export class BuscaUltimaAvaliacao {
  /** Numero de dias desde a ultima avaliação */
  diasDesdeUltimaAvaliacao!: number;

  [key: string]: any;

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.diasDesdeUltimaAvaliacao =
        _data['diasDesdeUltimaAvaliacao'] !== undefined
          ? _data['diasDesdeUltimaAvaliacao']
          : <any>null;
    }
  }

  static fromJS(data: any): BuscaUltimaAvaliacao {
    data = typeof data === 'object' ? data : {};
    let result = new BuscaUltimaAvaliacao();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['diasDesdeUltimaAvaliacao'] =
      this.diasDesdeUltimaAvaliacao !== undefined
        ? this.diasDesdeUltimaAvaliacao
        : <any>null;
    return data;
  }
}

export class BuscaUltimaAvaliacaoRetorno {
  data!: BuscaUltimaAvaliacao;

  [key: string]: any;

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.data = _data['data']
        ? BuscaUltimaAvaliacao.fromJS(_data['data'])
        : new BuscaUltimaAvaliacao();
    }
  }

  static fromJS(data: any): BuscaUltimaAvaliacaoRetorno {
    data = typeof data === 'object' ? data : {};
    let result = new BuscaUltimaAvaliacaoRetorno();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['data'] = this.data ? this.data.toJSON() : <any>null;
    return data;
  }
}

export class SetoresDB {
  id!: number;
  /** nome da area */
  nome!: string;
  /** descrição */
  descricao!: string;
  createdAt!: Date;
  updatedAt!: Date;

  [key: string]: any;

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
      this.nome = _data['nome'] !== undefined ? _data['nome'] : <any>null;
      this.descricao =
        _data['descricao'] !== undefined ? _data['descricao'] : <any>null;
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>null;
      this.updatedAt = _data['updatedAt']
        ? new Date(_data['updatedAt'].toString())
        : <any>null;
    }
  }

  static fromJS(data: any): SetoresDB {
    data = typeof data === 'object' ? data : {};
    let result = new SetoresDB();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['id'] = this.id !== undefined ? this.id : <any>null;
    data['nome'] = this.nome !== undefined ? this.nome : <any>null;
    data['descricao'] =
      this.descricao !== undefined ? this.descricao : <any>null;
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>null;
    data['updatedAt'] = this.updatedAt
      ? this.updatedAt.toISOString()
      : <any>null;
    return data;
  }
}

export class SetoresResponse {
  data!: SetoresDB[];

  [key: string]: any;

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(SetoresDB.fromJS(item));
      } else {
        this.data = <any>null;
      }
    }
  }

  static fromJS(data: any): SetoresResponse {
    data = typeof data === 'object' ? data : {};
    let result = new SetoresResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data)
        data['data'].push(item ? item.toJSON() : <any>null);
    }
    return data;
  }
}

export class SetorResponse {
  data!: SetoresDB;

  [key: string]: any;

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.data = _data['data']
        ? SetoresDB.fromJS(_data['data'])
        : new SetoresDB();
    }
  }

  static fromJS(data: any): SetorResponse {
    data = typeof data === 'object' ? data : {};
    let result = new SetorResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['data'] = this.data ? this.data.toJSON() : <any>null;
    return data;
  }
}

export class TipoAvaliacaoDB {
  id!: number;
  /** Tipo de avaliacao */
  nome!: string;
  /** Tipo de avaliacao */
  descricao!: string;
  createdAt!: Date;
  updatedAt!: Date;
  /** Pontuação Maxima */
  pontuacaoMaxima!: number;
  /** Pontuação Minima */
  pontuacaoMinima!: number;

  [key: string]: any;

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
      this.nome = _data['nome'] !== undefined ? _data['nome'] : <any>null;
      this.descricao =
        _data['descricao'] !== undefined ? _data['descricao'] : <any>null;
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>null;
      this.updatedAt = _data['updatedAt']
        ? new Date(_data['updatedAt'].toString())
        : <any>null;
      this.pontuacaoMaxima =
        _data['pontuacaoMaxima'] !== undefined
          ? _data['pontuacaoMaxima']
          : <any>null;
      this.pontuacaoMinima =
        _data['pontuacaoMinima'] !== undefined
          ? _data['pontuacaoMinima']
          : <any>null;
    }
  }

  static fromJS(data: any): TipoAvaliacaoDB {
    data = typeof data === 'object' ? data : {};
    let result = new TipoAvaliacaoDB();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['id'] = this.id !== undefined ? this.id : <any>null;
    data['nome'] = this.nome !== undefined ? this.nome : <any>null;
    data['descricao'] =
      this.descricao !== undefined ? this.descricao : <any>null;
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>null;
    data['updatedAt'] = this.updatedAt
      ? this.updatedAt.toISOString()
      : <any>null;
    data['pontuacaoMaxima'] =
      this.pontuacaoMaxima !== undefined ? this.pontuacaoMaxima : <any>null;
    data['pontuacaoMinima'] =
      this.pontuacaoMinima !== undefined ? this.pontuacaoMinima : <any>null;
    return data;
  }
}

export class TipoAvaliacoesResponse {
  data!: TipoAvaliacaoDB[];

  [key: string]: any;

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(TipoAvaliacaoDB.fromJS(item));
      } else {
        this.data = <any>null;
      }
    }
  }

  static fromJS(data: any): TipoAvaliacoesResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TipoAvaliacoesResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data)
        data['data'].push(item ? item.toJSON() : <any>null);
    }
    return data;
  }
}

export class TipoAvaliacaoResponse {
  data!: TipoAvaliacaoDB;

  [key: string]: any;

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.data = _data['data']
        ? TipoAvaliacaoDB.fromJS(_data['data'])
        : new TipoAvaliacaoDB();
    }
  }

  static fromJS(data: any): TipoAvaliacaoResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TipoAvaliacaoResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['data'] = this.data ? this.data.toJSON() : <any>null;
    return data;
  }
}

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else
    return _observableThrow(
      new SwaggerException(message, status, response, headers, null)
    );
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
